import type { BranchMapPoint } from "./BranchMap";
import { BranchRadiusSlider } from "./BranchRadiusSlider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

import { BranchMap } from "./BranchMap";

type BranchRadiusEditorProps = {
  branch: BranchMapPoint | null;
  radiusM: number;
  onRadiusChange: (value: number) => void;
  onSave: () => void;
  saving?: boolean;
  allBranches: BranchMapPoint[];
  onSelectBranch: (branch: BranchMapPoint) => void;
};

export function BranchRadiusEditor({
  branch,
  radiusM,
  onRadiusChange,
  onSave,
  saving,
  allBranches,
  onSelectBranch,
}: BranchRadiusEditorProps) {
  return (
    <div className="flex h-full min-h-[480px] flex-col gap-4 lg:flex-row">
      <div className="min-h-[360px] flex-1 lg:min-h-[520px]">
        <BranchMap
          branches={allBranches}
          selectedBranchId={branch?.id}
          onSelectBranch={onSelectBranch}
          showRadius
        />
      </div>

      <aside className="w-full shrink-0 space-y-4 rounded-xl border bg-card p-4 lg:w-80">
        <div>
          <h3 className="font-heading font-semibold text-base">ແກ້ລັດສະໝີບໍລິການ</h3>
          <p className="mt-1 text-muted-foreground text-sm">
            ເລືອກສາຂາຈາກແຜນທີ່ ຫຼື ລາຍການດ້ານລຸ່ມ
          </p>
        </div>

        {branch ? (
          <>
            <div className="rounded-lg border bg-muted/30 p-3">
              <p className="font-medium">{branch.name}</p>
              <p className="text-muted-foreground text-sm">{branch.code}</p>
            </div>

            <div className="space-y-4">
              <Label htmlFor="radius-m">ລັດສະໝີ (ແມັດ)</Label>
              <Input
                id="radius-m"
                type="number"
                min={0}
                step={100}
                value={Number.isNaN(radiusM) ? "" : radiusM}
                onChange={(e) => {
                  const v = e.target.value === "" ? 0 : Number(e.target.value);
                  onRadiusChange(v);
                }}
              />
              <BranchRadiusSlider
                value={radiusM}
                onChange={onRadiusChange}
                showValue={false}
              />
            </div>

            <Button className="w-full" onClick={onSave} isLoading={saving}>
              ບັນທຶກລັດສະໝີ
            </Button>
          </>
        ) : (
          <p className="text-muted-foreground text-sm">
            ກະລຸນາເລືອກສາຂາຈາກແຜນທີ່
          </p>
        )}

        <div className="max-h-48 space-y-1 overflow-y-auto border-t pt-3">
          <p className="mb-2 font-medium text-sm">ສາຂາທັງໝົດ</p>
          {allBranches.map((b) => (
            <button
              key={b.id}
              type="button"
              onClick={() => onSelectBranch(b)}
              className={`w-full rounded-lg px-2 py-1.5 text-left text-sm transition-colors hover:bg-muted ${
                b.id === branch?.id ? "bg-muted font-medium" : ""
              }`}
            >
              {b.code} — {b.name}
            </button>
          ))}
        </div>
      </aside>
    </div>
  );
}
